// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environment: 'dev',
  appUrl: 'https://ect2.dev.zonarsystems.net/',
  audience: 'http://apidev.zonarsystems.net/',
  clientID: 'i4XGlBd9wZyH4ACeAzsPoTmUtG4DPPx6',
  domain: 'zonar-dev.auth0.com',
  applicationId: '91d6481b-cd46-4600-b6aa-176770d1d170',
  defaultPermPrefix: 'ect2',
  redirectUrl: '/',
  defaultZonarRole: '02c1e612-e6d0-459e-91ce-b8b6eca5230b',
  companyApi: 'https://api-dev.zonarsystems.net/core/v1beta2',
  evirApi: 'https://api-dev.zonarsystems.net/evir/v2',
  region: 'NA',
  feature_flags: {
    isNewLanguageDictionary: true,
  },
  copyRightText: 'Zonar Systems',
  datadog: {
    enabled: false,
    applicationId: '6771fe23-e504-437a-b2cf-79d74fea313f',
    clientToken: 'pub1cc0c05dd55624b135b865328e6ca0a3',
    site: 'us5.datadoghq.com',
    service: 'inspection-builder',
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    excludedActivityUrls: ['localhost', '172.0.0.1'],
  },
  i18n: {
    supportedLanguages: ['en', 'en-GB', 'es', 'de', 'fr', 'it'],
    defaultLanguage: 'en',
    useBrowserLanguage: true,
  },
  pendo: {
    url: `https://cdn.pendo.io/agent/static/`,
    key: '47e63a49-4477-47c2-4ea6-0f032e1785d5',
  },
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
